import { SafeModule } from '../../../../../../../shared/pipe/safe/safe.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CabecalhoDireitaComponent } from './cabecalho-direita.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

@NgModule({
  declarations: [
      CabecalhoDireitaComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    RouterModule,
    LocalizeRouterModule,
    SafeModule
  ],
  exports: [
    CabecalhoDireitaComponent
  ]
})

export class CabecalhoDireitaModule { }
